
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5.664l-.742 1.86c.599.39 1.054.97 1.367 1.742.313.77.469 1.69.469 2.757 0 1.042-.156 1.948-.469 2.72-.307.765-.77 1.353-1.39 1.765-.615.411-1.365.617-2.25.617a4.359 4.359 0 01-1.446-.227l-.586 1.477h-.906l.734-1.844c-.594-.39-1.047-.969-1.36-1.734C.61 9.03.454 8.107.454 7.023c0-1.041.154-1.945.461-2.71.313-.771.776-1.362 1.39-1.774.62-.411 1.373-.617 2.259-.617.536 0 1.015.075 1.437.226L6.594.664H7.5zm-4.75 9.68l2.828-7.125a2.822 2.822 0 00-1.094-.211c-.895 0-1.573.338-2.03 1.015-.46.678-.688 1.678-.688 3 0 1.537.328 2.644.984 3.32zM6.29 3.71l-2.83 7.117c.324.14.688.211 1.095.211.896 0 1.573-.338 2.03-1.016.464-.682.696-1.682.696-3 0-1.526-.33-2.63-.992-3.312z","fill":"currentColor"}})])
          )
        }
      }
    